export default __webpack_public_path__ + "images/34ab53549b7e99e6293e1ea5923f2fb1-tour_6.gif";